import { IPriceSnapshot, IPriceSnapshotData } from '../pricesnapshot.types';
import { PriceSnapshot } from '../pricesnapshot';

export const mockPriceSnapshotsData = (): IPriceSnapshotData[] => [
  {
    id: 1000003,
    description: 'FAN ASSEMBLY - P2 BASE DESIGN',
    owner: 'John Doe',
    created_at: '2021-03-16 04:06:00'
  },
  {
    id: 1000004,
    description: 'SENSOR - CO2',
    owner: 'John Doe',
    created_at: '2021-03-16 04:06:00'
  }
];

export const mockPriceSnapshots = (
  data: IPriceSnapshotData[] = mockPriceSnapshotsData()
): IPriceSnapshot[] => data.map(item => new PriceSnapshot(item));
